import React, { useState } from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { endPoints } from '../../../config/end-points';
import useHttp from '../../../hooks/use-http';
import { authActions } from '../../../store/auth';

const VideoCredits = () => {
    const myCredits = useSelector((state) => state.auth.video_credits);
    const remaining_credits = useSelector((state) => state.auth.remaining_credits);
    const dispatch = useDispatch();
    const [Credits, setCredits] = useState({
        video_credits: 0,
        remaining_credits: 0
    });
    const { sendRequest } = useHttp();
    useEffect(() => {
        if(!myCredits || !remaining_credits){
            sendRequest(
                {
                  url: endPoints.getCreditsData,
                  body: "",
                  method: "GET",
                },
                (response) => {
                    if(response.status === 200){
                        // console.log(response.body.total_duration);
                        setCredits( prev => {
                            return {
                                ...prev, 
                                video_credits: response.body.total_credits, 
                                remaining_credits: response.body.total_credits - Math.floor(response.body.total_duration/60)
                            }
                        })

                        dispatch(authActions.setCredits({
                            video_credits: response.body.total_credits,
                            remaining_credits: response.body.total_credits - Math.floor(response.body.total_duration/60)
                        }));
                    }
                  // console.log(status);
                }
              );
        }
    }, [dispatch, myCredits, sendRequest,remaining_credits]);

    return (
        <>
            <div className="col-md-12 mb-4">
                <div className="bx_a">
                    <h5 className="mb-2 small_title d-flex">
                        Credits : 
                    </h5>
                    <div className='h6'><b>Video Credits</b> : {myCredits ? myCredits : Credits.video_credits} </div>
                    <div className='h6'><b>Remaining Credits</b> : {remaining_credits ? remaining_credits :Credits.remaining_credits} </div>
                </div>
            </div>
        </>
    )
}

export default VideoCredits